'use strict';

import Logger from "kernel/logger/Logger";
import resizeManager from "kernel/resizer/Resizer";
import FunctionQueue from "kernel/bootstrap/FunctionQueue";
//This is the a third party tracking component but works great for us too
import GameBusy from "adapters/components/GameBusy";
import bus from "kernel/messagebus/MessageBus";

/**
 * @module statecontroller/StateController
 * @memberof kernel
 * @description State Machine for subsystems Game/Console/Platform/Server
 * @requires {@link module:kernel/bootstrap/FunctionQueue}
 * @param {object} config Object containing messagebus, currency and clientConfig references
 * @param {function} done Continuation function to execute once StateController is initialised
 * @exports statecontroller/StateController
 * @example
 * import StateController from "kernel/statecontroller/StateController";
 * StateController(config,continuation);
 */

var widgetPauseHandler = (function() {
	var callAfterUnpause;
	var widgetPauseRequested;
	var gip = false;

	function notifyPaused(ifPaused) {
		bus.publish({
			channel: "GameService",
			topic: "IXF.ToWidgets",
			data: {messageType: 'gamePaused', messageData: ifPaused}
		});
	}
	//Widgets failed to load, or some other weirdness occured - we need to releasing all things that might 'wait' for
	// them - we will use this to unhook any actioned pauses.  //SKATE-6586 renamed this event to Widgets.ErrorHappened
	bus.subscribe({channel:"GameService", topic:"Widgets.ErrorHappened", callback:function(data) {
		if (widgetPauseRequested) {
			widgetPauseRequested = false;
			bus.publish({channel: 'Kernel', topic: 'BlockGame', data: { from:'WP', block:false } });
			//notifyPaused(false); //We don't care about this - widgets failed.
			if (callAfterUnpause) { //trigger continuation, if we got to the point where the game was paused.
				callAfterUnpause();
				callAfterUnpause = void(0);
			}
		}
		/*
		bus.publish({
			channel: "GameService",
			topic: "IXF.ToWidgets",
			data: {messageType: 'hide'}
		});
		 */
		bus.publish({ channel: "GameService", topic: "Widget.MuteHost", data: { muteHost: false} }); //roll back any host muting
	}});
	bus.subscribe({channel: "GameService", topic: "Widget.PauseHost", callback:function(data) {
		if (data?.widgetPauseRequested) { //Store the pause request
			widgetPauseRequested = data.widgetPauseRequested;
			if (!gip) { //Notify immediately if not currently locked into in a bet flow
				//This isn't the same as a resume GIP, technically.
				//Block as the game is currently outside of a game functionQueue / idle
				bus.publish({channel: 'Kernel', topic: 'BlockGame', data: { from:'WP', block:true } });
				notifyPaused(true); //
			}
		} else {
			widgetPauseRequested = false;
			if (callAfterUnpause) { //trigger continue
				callAfterUnpause();
				callAfterUnpause = void(0);
			}
			//Unblock as the game is currently outside of a game functionQueue / idle
			bus.publish({channel: 'Kernel', topic: 'BlockGame', data: { from:'WP', block:false } });
			notifyPaused(false);
		}
	}});

	return {
		ifWidgetPauseRequested : function() { //If widget is wanting a pause
			return !!widgetPauseRequested;
		},
		setUnpauseCallback : function(callback){ //Set a continue for state flow
			callAfterUnpause = callback;
		},
		inRound:function(ifInRound) {
			//Doesn't mean if we're in a bet, just if we're in the middle of a functionQueue.
			// If we are, we won't be by the end of a play and in a bonus we'll be checking if pause requested in each queue
			gip = ifInRound;
		},
		reset:function(triggerContinue) {
			gip = false; //Undo GIP
			widgetPauseRequested = false; //Not paused
			//For moments where we're not changing game mode (widget fail, not reInit) and
			// need to trigger the unpause callback.
			if (triggerContinue && callAfterUnpause) {
				callAfterUnpause();
			}
			callAfterUnpause = void(0);
		}
	};
})();

//define(function(require){

	var clientservice,consoleservice,reveal,gameservice;
	var nextState;
	var gameLogicResponse = {};
	var extraInfo = [];
	var paytableResponse = {};
	var currencyResponse = {};

	var clientConfig = {};
	var requestData = {};
	// Local balance holder own at least one prop *totalBalance*
	var currentBalance = {};
	var cashierUsed;
	var currency;
	var gameType;  // SKATE-845
	//var gameVersion;
	var gameVersionObj;
	var cecCommand;
	var gameDLErrorEnabled = false;
	var latestPFSGameList = [];

	var stake;
	var GIPGames;
	// State Blueprint
	var gameFlowMap = Object.freeze({
		'onStartGameInitial': {},
		'onStartGameInProgressStage': {},
		'onStartGameInProgressNextStage': {},
		'onBeforeShowStage': {},
		'onBeforeRequest': {},
		'onMakeRequest': {},
		'onAbortNextStage': {},
		'onResetNextStage': {},
		'onResolveStage': {},
		'onExitStage': {},
		'onInProgressStage': {},
		'onEnterNextStage': {},
		'onJackpot': {},
		'onEndGame': {},
		'onBeginNewGame': {}
	});


	function allowDeferredLoading(allow) {
		gameDLErrorEnabled = allow;
	}

	/**
	 * @function onStateChangeFail
	 * @description Handle Promise Errors from StateChange request-response
	 * @private
	 * @param e Error Stack
	 */
	function onStateChangeFail(e){
		 throw new Error('State Transition failed.',e);
	}

	// Maps game state to handler functions
	var gameProxy = Object.freeze({
		callHandler: function(state,nextStage,response){
//			console.log("%c ===[ " + state + " ]===", 'background: #00ff00; color: #000000');
			Logger.info("game: [ " + state + " ]");
			bus.request({ channel:'ClientService',topic:'StateChange', data:{state:state,nextStage:nextStage,response:response}},
			function(e){
				log(JSON.stringify(e));
				nextState();
			}, onStateChangeFail);
		}
	});


	/**
	 * @function getCurrentBalance
	 * @description Helper function to get current total balance value
	 * @private
	 */
	function getCurrentTotalBalance(){
		if(currentBalance && currentBalance.totalBalance){
			return currentBalance.totalBalance;
		}else if(gameLogicResponse){ //fall back to GLR
			return gameLogicResponse.OutcomeDetail.Balance;
		}
		return 0;
	}

	/**
	 * @function getCurrentPFSBalance
	 * @description Helper function to get current PFS balance value
	 * @private
	 */
	function getCurrentPFSBalance(){
		if(gameLogicResponse && gameLogicResponse.Balances && gameLogicResponse.Balances.Balance){ //fall back to GLR
			var balance = !Array.isArray(gameLogicResponse.Balances.Balance) 
				? [gameLogicResponse.Balances.Balance] 
				: gameLogicResponse.Balances.Balance;
			var pfsBalanceEntry = balance.find(function(b){
				b["@name"] === "FREESPIN";
			});
			return pfsBalanceEntry ? Number(pfsBalanceEntry["#text"]) : 0;
		}
		return 0;
	}
	/**
	 * @function getTotalBalanceForPFS
	 * @description Helper function to get current balance value from the sum of all Balance's attributes
	 * @private
	 */
	function getTotalBalanceForPFS(balances){
		if(gameLogicResponse.PromotionalFreeSpin && balances){
			if(balances["@totalBalance"]){
				return balances["@totalBalance"];
			}
			if(balances.Balance){				
				var balance = !Array.isArray(balances.Balance) ? [balances.Balance] : balances.Balance;
				return balance.reduce(function(prev, cur){
					return cur["@name"] !== "FREESPIN" ? prev + parseFloat(cur["#text"]) : prev;
				}, 0);
			}
		}
		return -1;
 	}

	/**
	 * @function setCurrentTotalBalance
	 * @description Helper function for setting current total balance value
	 * @private
	 */
	function setCurrentTotalBalance(value){
		currentBalance = {totalBalance: value};
	}

	var bypassStakeDeduction;

	/**
	 * @function deductStake
	 * @description Determines the stake deducted balance and sends new value over the bus to subscribers
	 * @private
	 * @param value The stake value that is to be deducted from the current Balance
	 */
	function deductStake(value){
		if (bypassStakeDeduction) { //Usually the case for GCM
			return;
		}
		// Check for promotional freespin session before executing the deduction
		if(!gameLogicResponse.PromotionalFreeSpin){
			var currentBalance = +((getCurrentTotalBalance() - value).toFixed(8)); //In case of IEEE rounding errors
			setBalance(currentBalance);
		} else {
			Logger.warn("Promo Rounds do not require stake deduction.");
		}

	}

	/**
	 * @function setBalance
	 * @private
	 * @description Helper method to determine whether Balance or Promotional FreeSpin Count should be changed
	 * @param value The unformatted balance value
	 * @param balancesNode The RGS Balances node
	 * @param pfsBalanceValue optional node for value of PFS balance
	 */
	function setBalance(value, balancesNode, pfsBalanceValue){
		var formattedValue = currency.formatFloat(Math.max(0,value));

		var balancesNodeObj = void(0);

		if(!balancesNode){// use the GLR balances node instead
			balancesNode = gameLogicResponse.Balances?gameLogicResponse.Balances.Balance:void(0);
		}

		if(balancesNode){
			balancesNodeObj = {};

			if(!Array.isArray(balancesNode)){
				balancesNode = [balancesNode];
			}
			//balance node should be consistence with gameOutcome Balance node
			balancesNode.forEach( function(b) {
				balancesNodeObj[b['@name']] = {
					amount: parseFloat(b['#text']) || 0,
					formattedAmount: currency.formatFloat(Math.max(0, b['#text']))
				};
			});
		}

		if(gameLogicResponse.PromotionalFreeSpin){
			var freespinCount = gameLogicResponse.PromotionalFreeSpin["@count"];
			// The console's balance should be initialize in PFS model
			// The balance value should only have CASH and BONUS's wallet
			consoleservice.setBalance(pfsBalanceValue, currency.formatFloat(Math.max(0, pfsBalanceValue)), balancesNodeObj);
			// Backward compatible as some game (such as Icy Wilds) rely on this message
			// For showing formatted balance
			clientservice.setBalance({balance: formattedValue, freespin: freespinCount, balanceValue: value});
		}else{
			consoleservice.setBalance(value, formattedValue, balancesNodeObj);

			// Backward compatible as some game (such as Icy Wilds) rely on this message
			// For showing formatted balance
			clientservice.setBalance({balance: formattedValue, balanceValue: value});
		}
	}

	/**
	 * @function log
	 * @private
	 * @description Simple Logging for State Controller
	 * @param val
	 */
	function log(message){
		Logger.log("com.igt.skateboard: " + message, 'kernel/StateController');
	}

	/**
	 * @function wrapNextState
	 * @description Helper method for chaining state flows
	 * @private
	 * @param wrapped
	 * @returns {Function}
	 */
	function wrapNextState(wrapped){

		if(!(wrapped instanceof Function)){
			throw new Error('wrapped must be a function that is defined in this window');
		}

		return function(next){
			//set the global nextState function to call whatever is in the first argument
			nextState = function(){
				if(!next){
					throw new Error('com.igt.skateboard: nextState called twice from Game Client.');
				}
				window.setTimeout(next,0);
				next = null;
			};
			//delegate the rest to the wrapped function
			log(wrapped.name);
			wrapped.apply(void 0,Array.prototype.slice.call(arguments,1));
		};
	}

	// State Transition callback
	var done = function(){
		nextState();
	};

	// Initialisation Queue
	var initQueue = FunctionQueue.apply(void 0,[
		function onBeforeInitGame(){
			allowDeferredLoading(false);
			consoleservice.beforeInitGame(function(usedCashier){
				cashierUsed = usedCashier;
				//console.log("Used Cashier:",cashierUsed);
				log("Used Cashier: " + cashierUsed);
				done();
			});
		},
		function onInitRequest(){
			clientservice.initrequest(function(data){
				gameLogicResponse = JSON.parse(JSON.stringify(data.gamelogicresponse));
				paytableResponse = JSON.parse(JSON.stringify(data.paytableresponse));
				currencyResponse = JSON.parse(JSON.stringify(data.currencyresponse));
				getExtraInfos(data);
				done();
			});
		},
		function onCleanSwitchFlags(){
			//clear the switch mode flags after the mode switched
			clientservice.clearSwitchPlayMode();
			done();
		},
		function onSetCurrentBalance(){
			setCurrentTotalBalance(gameLogicResponse.OutcomeDetail.Balance);
			done();
		},
		function showMessagesFromInitState(){
			consoleservice.showAnyMessages(done);
		},
		function onInitOutcome(){
			if(gameLogicResponse.PromotionalFreeSpin){
				// Freeze the bet per pattern values for promotional freespins
				var params = {}, checkList = ['freespin_lines', 'freespin_bet', 'freespin_num', 'freespin_remain'];
				checkList.forEach(function(item){
					if(clientConfig.serverConfig.hasOwnProperty(item) && clientConfig.serverConfig[item] !== undefined && clientConfig.serverConfig[item] !== null){
						params[item] = clientConfig.serverConfig[item];
					}
				});
				//  SKATE-3007
				if(params.hasOwnProperty('freespin_lines')&&paytableResponse.PatternSliderInfo && paytableResponse.PatternSliderInfo.PatternInfo){
					paytableResponse.PatternSliderInfo.PatternInfo['@min'] = params.freespin_lines;
					paytableResponse.PatternSliderInfo.PatternInfo['@max'] = params.freespin_lines;
					paytableResponse.PatternSliderInfo.PatternInfo.Step = [params.freespin_lines];
				}
			}

			if(gameservice){
				gameservice.setGameStillActive(true);
			}
			GameBusy("GameReady",true); //Set busy waiting for GameReady
			bus.publish({channel: "Kernel", topic: "Game.GameOutcome", data: { //Keep
					event:'initOutcome',
					outcome: gameLogicResponse
				}});
			consoleservice.initOutcome(gameLogicResponse, done);
		},
		function onInitGame(){

			bus.subscribe({channel:'Game',topic:'Game.InitDone',callback:function(data,envelope){
				if (gameVersionObj) {
					consoleservice.sendMessage("gameversion", gameVersionObj);
				} else {
					//This is where we need to manually extract the versioning
					var version = data.version;
					if (typeof version !== 'object') {
						version = {
							gameVersion : data.version,
							gleVersion : clientConfig.gameVersion
						};
					}
					if (clientConfig.serverConfig.gameVersion) {
						version.gameServerVersion = clientConfig.serverConfig.gameVersion;
						version.gameServerVersionShort = clientConfig.serverConfig.gameVersion.split('.', 2).join('.');
					}
					consoleservice.sendMessage("gameversion",version); //data.version seems to be coming from the game, it's probably an object.
				}
				done();
			}});

			var gameInitData = {
				GameLogicResponse:gameLogicResponse,
				PaytableResponse:paytableResponse,
				CurrencyResponse:currencyResponse
			};

			bus.publish({channel: 'ClientService', topic: 'Game.Init', data: gameInitData});
		},
		function onRegisterControls(){
			consoleservice.registerControls(done);
		},
		function onHandlerExtraInfos() {
			handlerExtraInfos(extraInfo);
			done();
		},
        function checkSound() {
			if (clientConfig.kernelConfig.showSoundPrompt) { //SKATE-5546 - if we show popup
				clientservice.checkSound(function (startWithSound) {
					bus.publish({channel: 'Kernel', topic: 'Game.StartMuted', data: startWithSound});
					done();
				});
			} else {
				done();
			}
		},
		function onBeforeShowStage(){
			var balanceSumPfs = getTotalBalanceForPFS(gameLogicResponse.Balances);
			setBalance(gameLogicResponse.OutcomeDetail.Balance, undefined, balanceSumPfs);
			if(gameLogicResponse.OutcomeDetail.GameStatus==='InProgress'){
				//Setting game busy here, before we turn off gameready's blocker
				GameBusy("WagerState",true);
				gameProxy.callHandler('onBeforeShowStage',gameLogicResponse.OutcomeDetail.Stage,gameLogicResponse);
				//Ignore the stage and use NextStage if the game is not in progress
                consoleservice.enableConsoleControls(false);
				if(gameservice){
					gameservice.setGameInProgress(true);
				}
			}else{
				gameProxy.callHandler('onBeforeShowStage',gameLogicResponse.OutcomeDetail.NextStage,gameLogicResponse);
			}
		},
		function revealGame(){
			if (clientConfig?.widgetConfig?.connectorUrl && clientConfig?.serverConfig?.widgetsEnabled) {
				bus.publish({channel: "GameService", topic: "Widgets.FromIXF", data: {messageType: 'reveal'}});
			}
			GameBusy("GameReady",false);
			consoleservice.gameReady(function(){
				reveal();
				done();
			});
		},
		function onStartGameInProgressStage(){
			if(gameLogicResponse.OutcomeDetail.GameStatus==='InProgress'){
				allowDeferredLoading(true);
				clientservice.setGameInProgress(true);
				// fix SKATE-925
				consoleservice.sendMessage('wagerIsStarting');
				GameBusy("WagerState",true);
				gameProxy.callHandler('onStartGameInProgressStage',gameLogicResponse.OutcomeDetail.Stage,gameLogicResponse);
				bus.publish({channel: "GameService", topic: "IXF.ToWidgets", data: {messageType: 'gameStart', messageData:{status:"WagerResumed"}}});//SKATE-5989 Should we just stick to WagerStarted?
			}else{
				if(gameservice){
					gameservice.setGameInProgress(false);
				}
				clientservice.setGameInProgress(false);
				done();
			}

		},
		function onStartGameInProgressNextStage(){
			if(gameLogicResponse.OutcomeDetail.GameStatus==='InProgress'){
				gameProxy.callHandler('onStartGameInProgressNextStage',gameLogicResponse.OutcomeDetail.NextStage,gameLogicResponse);
			}else{
				done();
			}
		},
		function onStartGameInitial(){

			cecCommand.setGameLogicResponse(gameLogicResponse);
			cecCommand.postGameLaunched(clientConfig.serverConfig.denomamount);

			if(gameLogicResponse.OutcomeDetail.GameStatus==='Initial'){
				allowDeferredLoading(false);
				gameProxy.callHandler('onStartGameInitial',gameLogicResponse.OutcomeDetail.NextStage,gameLogicResponse);
                consoleservice.enableConsoleControls(true);
			}else{
				done();
			}
		}
	].map(wrapNextState));


	//  ReInitialisation Queue
	var reInitQueue = FunctionQueue.apply(void 0,[
		function onUpdateParams(){
			widgetPauseHandler.reset(false); //SKATE-6511 - Clear any pause and handlers
			//Block game interaction for reinit
			bus.publish({channel: 'Kernel', topic: 'BlockGame', data: true });
			allowDeferredLoading(false);
			if(!!clientservice.getSwitchPlayMode()){
				done();
			}else{
				//legacy for TRY TO BUY, which is trigged by Game
				consoleservice.onUpdateParams(done);
			}
		},
		function onReInitGameService() {
			// re-init gameservice
			GameBusy("GameReady",true);
			GameBusy("WagerState",false); //Clear any pending gameplay tag
			if(gameservice) {
				bus.publish({channel: "GameService", topic: "IXF.ToWidgets", data: {messageType: 'gameEnd', messageData:{status:"ReInit"}}});
				gameservice.reInit(done);
			} else {
				done();
			}
		},
		function onClearMessage() {
			consoleservice.clearMessage();
			done();
		},
		function onReLaunchRequest(){
			clientservice.reLaunchrequest(done);
		},
		function onCleanSwitchFlags(){
			//clear the switch mode flags after the mode switched
			clientservice.clearSwitchPlayMode();
			clearExtraInfo();
			done();
		},
		// TODO add handlerExaInfos()
		function onReInitRequest(){
			clientservice.initrequest(function(data){
				gameLogicResponse = JSON.parse(JSON.stringify(data.gamelogicresponse));
				paytableResponse = JSON.parse(JSON.stringify(data.paytableresponse));
				currencyResponse = JSON.parse(JSON.stringify(data.currencyresponse));
				getExtraInfos(data);
				done();
			});

		},
		function onSetCurrentBalance(){
			setCurrentTotalBalance(gameLogicResponse.OutcomeDetail.Balance);
			done();
		},
		function showMessagesFromInitState(){
			consoleservice.showAnyMessages(done);
		},
		function onInitOutcome(){
			if(gameLogicResponse.PromotionalFreeSpin){
				// Freeze the bet per pattern values for promotional freespins
				var params = {}, checkList = ['freespin_lines', 'freespin_bet', 'freespin_num', 'freespin_remain'];
				checkList.forEach(function(item){
					if(clientConfig.serverConfig.hasOwnProperty(item) && clientConfig.serverConfig[item] !== undefined && clientConfig.serverConfig[item] !== null){
						params[item] = clientConfig.serverConfig[item];
					}
				});

				//  SKATE-3092
				if(params.hasOwnProperty('freespin_lines')&&paytableResponse.PatternSliderInfo && paytableResponse.PatternSliderInfo.PatternInfo){
					paytableResponse.PatternSliderInfo.PatternInfo['@min'] = params.freespin_lines;
					paytableResponse.PatternSliderInfo.PatternInfo['@max'] = params.freespin_lines;
					paytableResponse.PatternSliderInfo.PatternInfo.Step = [params.freespin_lines];
				}
			}

			if(gameservice){
				gameservice.setGameStillActive(true);
			}
			bus.publish({channel: "Kernel", topic: "Game.GameOutcome", data: { //Remove when PromotionFreespinIXFController changed
				event:'initOutcome',
				outcome: gameLogicResponse
			}});
			consoleservice.initOutcome(gameLogicResponse, done);
		},
		function onReInitGame(){
			//done();
			//  SKATE-1112
			var reInitDoneSubscriber = bus.subscribe({channel:'Game',topic:'Game.ReInitDone',callback:function(data,envelope){
				if(gameVersionObj){
					consoleservice.sendMessage("gameversion", gameVersionObj);
				}else{
					consoleservice.sendMessage("gameversion", data.version);
				}
				bus.unsubscribe(reInitDoneSubscriber);
				done();
			}});

			var reInitData = {
				GameLogicResponse:gameLogicResponse,
				CurrencyResponse:currencyResponse,
				PaytableResponse:paytableResponse
			};

			//  SKATE-3114 : bet value should not be selected for lottery PFS
			//if(gameType !== 'L') {
			//	reInitData.PaytableResponse = paytableResponse;
			//}
			let blocker = document.getElementById('IXFgameBlocker');
			if (blocker) {
				blocker.style.visibility = 'hidden'; //Just in case left over from reinit
			}
			bus.publish({channel:'ClientService',topic:'Game.ReInit',data: reInitData});
		},
		function onHandlerExtraInfos() {
			if(extraInfo && extraInfo.length > 0){
				handlerExtraInfos(extraInfo);
			} else {
				registerPFSInfoNotification(); //clear the pfs info on console with an empty data
			}
			done();
		},
		function onBeforeShowStage(){
			//Unblock game interaction for reinit
			var balanceSumPfs = getTotalBalanceForPFS(gameLogicResponse.Balances);
			setBalance(gameLogicResponse.OutcomeDetail.Balance, undefined, balanceSumPfs);
			if(gameLogicResponse.OutcomeDetail.GameStatus==='InProgress'){
				GameBusy("WagerState",true);
				gameProxy.callHandler('onBeforeShowStage',gameLogicResponse.OutcomeDetail.Stage,gameLogicResponse);
				//Ignore the stage and use NextStage if the game is not in progress
                consoleservice.enableConsoleControls(false);
				if(gameservice){
					gameservice.setGameInProgress(true);
				}
			}else{
				gameProxy.callHandler('onBeforeShowStage',gameLogicResponse.OutcomeDetail.NextStage,gameLogicResponse);
			}
		},
		function revealGame(){
			GameBusy("GameReady", false);
			consoleservice.gameReady(function(){
				reveal();
				bus.publish({channel: 'Kernel', topic: 'BlockGame', data: false });
				done();
			});
		},
		function onStartGameInProgressStage(){
			if(gameLogicResponse.OutcomeDetail.GameStatus==='InProgress'){
				GameBusy("WagerState",true);
				allowDeferredLoading(true);
				clientservice.setGameInProgress(true);
				// fix SKATE-925
				consoleservice.sendMessage('wagerIsStarting');
				gameProxy.callHandler('onStartGameInProgressStage',gameLogicResponse.OutcomeDetail.Stage,gameLogicResponse);
			}else{
				if(gameservice){
					gameservice.setGameInProgress(false);
				}
				clientservice.setGameInProgress(false);
				done();
			}

		},
		function onStartGameInProgressNextStage(){
			if(gameLogicResponse.OutcomeDetail.GameStatus==='InProgress'){
				gameProxy.callHandler('onStartGameInProgressNextStage',gameLogicResponse.OutcomeDetail.NextStage,gameLogicResponse);
			}else{
				done();
			}
		},
		function onStartGameInitial(){
			if(gameLogicResponse.OutcomeDetail.GameStatus==='Initial'){
				gameProxy.callHandler('onStartGameInitial',gameLogicResponse.OutcomeDetail.NextStage,gameLogicResponse);
                consoleservice.enableConsoleControls(true);
			}else{
				done();
			}
		}
	].map(wrapNextState));

	var txStartTime = 0;		//SKATE-2655
	var transactionDelay = 0;	//SKATE-2655

	// Main Game loop Queue
	var beforeRequestQueue = FunctionQueue.apply(void 0,[
		//SKATE-1143
		function waitForUnPause(){
			widgetPauseHandler.inRound(true); //Flagging this so we don't autoreply
			allowDeferredLoading(false); //Disable while making requests - these errors should only get thrown during the transitions or initial gip stuff
			if(consoleservice.isGamePaused()){
				Logger.warn('com.igt.game: waiting for unPause');
				consoleservice.setUnPauseGame(done);
			}else{
				done();
			}
		},
        function waitForWidgetUnpause() { //If a bet starts, such as autospin, wait for unpause
			if (gameLogicResponse.OutcomeDetail.GameStatus === 'InProgress') { //Don't let the widget pause until the end of the host game
				done();
			} else {
				//If widget requested a pause just as a request starts, we should probably ignore it actually.
				//We're already kinda committed.
				if (widgetPauseHandler.ifWidgetPauseRequested()) {
					widgetPauseHandler.setUnpauseCallback(done); //We're paused, wait for reply
					//Notifying widgets because otherwise there's a chance we'll just hit a wall here
					bus.publish({channel: "GameService", topic: "IXF.ToWidgets", data: {messageType: 'gamePaused', messageData:true}});
					//I think in this case they already know - the on endgame and the immediate callback would've satisfied this.
				} else {
					done();
				}
			}
		},
		function checkReplayPause(){
			allowDeferredLoading(false);
			if(consoleservice.isReplayPaused()){
                Logger.warn('com.igt.game: waiting for replay unPause');
                consoleservice.setUnPauseReplay(done);
            }else{
				done();
			}
		},
		function checkReplayEnd(){
			if(!clientservice.isReplayEnd()){
				done();
			}
		},
		function checkPlayerOptedInToPlay() {
			clientservice.checkPlayPermitted(
				done,
				function(){
					afterAbortQueue.execute(beforeRequestQueue.execute);
				}
			);
		},
		function wagerStarted(){
			if(gameservice){//game round started
				gameservice.setInGameRound(true, "wagerStarted");
				if (gameLogicResponse.OutcomeDetail.GameStatus !== 'InProgress') { //No need to repeat to Widget for the same Wager
					bus.publish({channel: "GameService", topic: "IXF.ToWidgets", data: {messageType: 'gameStart', messageData:{status:"WagerStarted"}}});
				}
				//SKATE-4572:The Leaderboard information and Spin left is not updated after network reconnect
			}
			GameBusy("WagerState",true);
			//SKATE-6545: Adding safety net for games that don't tell us pages were closed.
			GameBusy('paytable',false);
			GameBusy('howToPlay',false);
			GameBusy('settings',false);
			consoleservice.wagerStarted(done, function () { //cancellation handler from wagerStarted by console
				afterAbortQueue.execute(beforeRequestQueue.execute);
				//TODO - Remove the ability to abort from wagerStarted
				//It can't work with PT and probably not 3P games either, so we should remove it to simplify.
				//It was never used in any console, so nothing will break.
			});
		},
		function onBeforeRequest(){
			if (gameLogicResponse.OutcomeDetail.GameStatus !== 'InProgress') { //SKATE-2655
				txStartTime = Date.now(); //Set timer for the start for visual Transaction Delay SKATE-2655
			}
			// SKATE-924: balance does not need update here
			//setBalance(gameLogicResponse.OutcomeDetail.Balance);
			gameProxy.callHandler('onBeforeRequest',gameLogicResponse.OutcomeDetail.NextStage,gameLogicResponse);
		},
		function onMakeRequest(){
			gameProxy.callHandler('onMakeRequest',gameLogicResponse.OutcomeDetail.NextStage,gameLogicResponse);
		},
		//  SKATE-2586: Client side management Insufficient funds for table games
		function doInsufficientFundCheck() {
			if( clientConfig.serverConfig.playMode !== 'replay' && clientConfig.serverConfig.blockInsufficientFund === true && clientConfig.gameConfig.gameType === "T" ){
				if (stake && stake > 0) {
					clientservice.getPlayerBalance(function (balance) {
						//SKATE-4647:TechFlow: Add table warn popup to current flow
						if(clientConfig.serverConfig.paramRGS && clientConfig.serverConfig.paramRGS.playMode === 'freespin'){
							var freespinBalance =0;
							if(balance && balance.Balance){
								var balanceNode = !Array.isArray(balance.Balance) ? [balance.Balance] : balance.Balance;
								balanceNode.forEach(function(b) {
									if(b['@name']=== "FREESPIN"){
										freespinBalance = Number(b['#text']);
									}
								});
							}
							
							if(freespinBalance >= stake){
								done();
							}else{
								// insufficient fund for table game
								clientservice.throwPFSTableBetWarn();
							}
						}else{
							if (Number(balance["@totalBalance"]) >= stake) {
								done();
							} else {
								// client side insufficient fund
								clientservice.throwInsufficientFoundError(done);
							}
						}
						
					}, function () { // If get balance call fail, using client side balance to do check
						if (clientConfig.serverConfig.paramRGS && clientConfig.serverConfig.paramRGS.playMode === 'freespin') {
							if(getCurrentPFSBalance() >= stake) {
								done();
							}else{
								// insufficient fund for table game
								clientservice.throwPFSTableBetWarn();
							}
						} else {
							if(getCurrentTotalBalance() >= stake) {
								done();
							}else{
								// client side insufficient fund
								clientservice.throwInsufficientFoundError(done);
							}
						}
					});
				} else {
					done();
				}
			}else{
				done();
			}

		},
		function doRequest(){
			clientservice.playrequest(function(data){
				//gameLogicResponse = data.gameLogicResponse;
				gameLogicResponse = data.RGSResponse.GameLogicResponse;
				if(data.ExtraInfo){
					extraInfo.push(JSON.parse(JSON.stringify(data.ExtraInfo)));

					handlerExtraInfos(extraInfo);

				}
				if(gameLogicResponse.TransactionId){
						afterResponseQueue.execute(beforeRequestQueue.execute);
				}else{
					//transaction was not a success, it was voided
					//most common reason is not enough funds
					Logger.warn('com.igt.skateboard: Transaction was aborted');
					afterAbortQueue.execute(beforeRequestQueue.execute);
				}
			});
		}
	].map(wrapNextState));

	// Successful Response Queue
	var afterResponseQueue = FunctionQueue.apply(void 0,[
		function onSetCurrentBalance(){
			setCurrentTotalBalance(gameLogicResponse.OutcomeDetail.Balance);
			done();
		},
		function onCheckInterruptedMessageBeforeOnResolveStage(){
			//SKATE-1837, if next stage is in GIP, waiting for 10s to show interrupted message if player not
			//interactive with the game for 10s when game is going to enter into a bonus stage
			if(gameLogicResponse.OutcomeDetail.GameStatus === 'InProgress' &&
				gameLogicResponse.OutcomeDetail.Stage !== gameLogicResponse.OutcomeDetail.NextStage){
				// SKATE-2117 - set gip for gsp
				if(gameservice){
					gameservice.setGameInProgress(true);
					//SKATE-2227
					gameservice.setInGameRound(true, "onAllowInterruptedMessage");
				}
				clientservice.setGameInProgress(true);
				// when GIP and is going to enter into next stage,
				// SKATE-1866
				// which means any interrupted message could display immediately
				consoleservice.setAllowInterruptedMessage(true);
                consoleservice.enableConsoleControls(false);

				if(consoleservice.hasInterruptedMessage()){ // in case the message already exist at the moment
					consoleservice.showAnyMessages(done);
				}else{
					done();
				}
			}else{
				// SKATE-2933: the progress bar is updated after the current hand is finished, it's later than leaderboard updated or prize award award.
				if(gameservice){
					var gip = gameLogicResponse.OutcomeDetail.GameStatus === 'InProgress';
					gameservice.setGameInProgress(gip, true);
				}
				done();
			}
		},
		function onResolveStage(){
			// Workaround for updating transaction ID for lottery games
			// As lottery game will block 'onResolveStage' until 'reveal all' (2nd play call) requested
			if(gameLogicResponse.OutcomeDetail.GameStatus === 'InProgress' &&
				gameLogicResponse.OutcomeDetail.Stage === 'Scenario'){
				let balanceSumPfs = getTotalBalanceForPFS(gameLogicResponse.Balances);
				// consoleservice.gameOutcome(gameLogicResponse, function() {//Continuation after console
				//
				// });
				//Not sending this to the console.  This is because a) it gets sent in the next stage and b) the JSON
				// TransactionID is THE SAME as the final Transaction ID.  Will need to ask upstream about this.
				// It will get sent as soon as the player clicks reveal, but they have no need to know about this until
				// then as it isn't even an actual outcome, but a mid-stage thing for IW.
				setBalance(gameLogicResponse.OutcomeDetail.Balance, undefined, balanceSumPfs);
			}else{
				if (clientConfig.serverConfig.paramRGS &&
					clientConfig.serverConfig.paramRGS.wagerType &&
					clientConfig.serverConfig.paramRGS.wagerType === "TRY") {
					//Try mode, do nothing
				} else {
					let balanceSumPfs = getTotalBalanceForPFS(gameLogicResponse.Balances);
					//set diplayed balance to returned balance - payout, as the sever value might have changed since the last spin completed
					//setBalance(gameLogicResponse.OutcomeDetail.Balance - currency.toCurrency(gameLogicResponse.OutcomeDetail.Payout));
					setBalance(+((gameLogicResponse.OutcomeDetail.Balance -
								  currency.toCurrency(gameLogicResponse.OutcomeDetail.Payout)).toFixed(8)), undefined, balanceSumPfs);
				}
			}
			gameProxy.callHandler('onResolveStage', gameLogicResponse.OutcomeDetail.Stage, gameLogicResponse);
		},
		function sendOutcome(){
			//Game is Active wheneve it gets outcome
			if(gameservice){
				gameservice.setGameStillActive(true);
			}
			//We should check if it's a GIP Instant Win, because they use the same TX ID and that's a problem.
//			if(gameLogicResponse.OutcomeDetail.GameStatus === 'InProgress' &&
//				gameLogicResponse.OutcomeDetail.Stage === 'Scenario'){
//				done(); //Instant win, this is a middle state, not a bonus transition
//			} else {
				bus.publish({
					channel: "Kernel", topic: "Game.GameOutcome", data: { //Remove when PromotionFreespinIXFController changed
						event: 'gameOutcome',
						outcome: gameLogicResponse
					}
				});
				consoleservice.gameOutcome(gameLogicResponse, done);
//			}
		},
		function onHandlerExtraInfos() {
			handlerExtraInfos(extraInfo);
			done();
		},
		function onInProgressStage(){
			if(gameLogicResponse.OutcomeDetail.GameStatus==='InProgress' &&
				gameLogicResponse.OutcomeDetail.Stage===gameLogicResponse.OutcomeDetail.NextStage
			){
				if(gameservice){
					// SKATE-4650 *Progress bar* is not updated until game start next spin
					// progressBufferList has value but gameInProgress was true, so return in original flush function
					// here add a second parameter forceFlush to force flush progressBufferList
					gameservice.setGameInProgress(true, true);
				}
				clientservice.setGameInProgress(true);
				// SKATE-4650 *Award message* is not updated until game start next spin
				// checkPDWinAfterRound is after onInProgressStage, if wants to show award message onInProgressStage we must mix it into here
				// different with normal bonus game, this done function is waiting for game's reply, and game will send it after player click spin button
				gameProxy.callHandler('onInProgressStage',gameLogicResponse.OutcomeDetail.Stage, gameLogicResponse);
			}else{
				// SKATE-2933: the progress bar is updated after the current hand is finished, it's late than leader board updated or prize award award.
				if(gameservice){
					var gip = gameLogicResponse.OutcomeDetail.GameStatus === 'InProgress';
					gameservice.setGameInProgress(gip, true);
				}
				done();
			}
		},
		function onCheckInterruptedMessageBeforeOnExitStage(){
			//SKATE-2227
			if(gameLogicResponse.OutcomeDetail.GameStatus === 'InProgress' &&
				gameLogicResponse.OutcomeDetail.Stage !== gameLogicResponse.OutcomeDetail.NextStage){
			 
				if(consoleservice.hasInterruptedMessage()){
					consoleservice.showAnyMessages(done);
				}else{
				  done();
				}
			}else{
				done();
			}
		},
		function onExitStage(){
			if(gameLogicResponse.OutcomeDetail.Stage!==gameLogicResponse.OutcomeDetail.NextStage){
				allowDeferredLoading(true);
				if(gameservice){
					//SKATE-2227
					gameservice.setInGameRound(true, "onExitStage", gameLogicResponse.OutcomeDetail.NextStage);
				}
				gameProxy.callHandler('onExitStage',gameLogicResponse.OutcomeDetail.Stage,gameLogicResponse);
			}else{
				done();
			}
		},
		function onEnterNextStage(){
			if(gameLogicResponse.OutcomeDetail.Stage!==gameLogicResponse.OutcomeDetail.NextStage){
				allowDeferredLoading(true);
				gameProxy.callHandler('onEnterNextStage',gameLogicResponse.OutcomeDetail.NextStage,gameLogicResponse);
			}else{
				done();
			}
		},
		function onClearAllowInterruptedMessage(){
			allowDeferredLoading(false);
			//SKATE-1837, SKATE-1866, clear allow interrupted message
			consoleservice.setAllowInterruptedMessage(false); //SKATE-1849 - this needs to be cleared *before* transitioning
			if(gameservice){
				gameservice.setInGameRound(true, "offAllowInterruptedMessage");
			}
			done();
		},
		function onEndGame(){
			if(gameLogicResponse.OutcomeDetail.GameStatus==='Start'){
				var balanceSumPfs = getTotalBalanceForPFS(gameLogicResponse.Balances);
				allowDeferredLoading(false);
				setBalance(gameLogicResponse.OutcomeDetail.Balance, undefined, balanceSumPfs);
				gameProxy.callHandler('onEndGame',gameLogicResponse.OutcomeDetail.NextStage, gameLogicResponse);
				consoleservice.enableConsoleControls(true); //Note - this is just the PF-registered controls, not all controls
			}else{
                done();
			}
		},
		function closeGameRoundBeforeShowMessage(){
			if(gameservice && gameLogicResponse.OutcomeDetail.GameStatus !== 'InProgress'){//game round is ended
				gameservice.setInGameRound(false, "beforeShowMessage");
			}
			done();
		},
		function showMessagesAfterEndGame(){
			if(gameLogicResponse.OutcomeDetail.GameStatus !== 'InProgress' || consoleservice.hasInterruptedMessage()){
				consoleservice.showAnyMessages(done);
			}else{
				done();
			}

		},
		function closeGameRoundAfterShowMessage(){ //Fix gameRound showing as complete when it is not.
			if(gameservice && gameLogicResponse.OutcomeDetail.GameStatus !== 'InProgress'){//game round is ended
				gameservice.setInGameRound(false, "afterShowMessage");
			}
			done();
		},
		function wagerComplete(){ //From this point on, GLR balance has to be treated as 'dirty'.
			if(gameLogicResponse.OutcomeDetail.GameStatus !== 'InProgress') {
				allowDeferredLoading(false);
				consoleservice.wagerComplete(done);
				GameBusy("WagerState",false);
				if(gameservice){
					gameservice.setInGameRound(false, 'wagerComplete');
					gameservice.setGameInProgress(false);
					bus.publish({channel: "GameService", topic: "IXF.ToWidgets", data: {messageType: 'gameEnd', messageData:{status:"WagerComplete"}}});
				}
				clientservice.setGameInProgress(false);
			} else {
				done();
			}
		},
		function waitForUnPause(){
			if(consoleservice.isGameHalted()){
				allowDeferredLoading(false);
				//clientservice.closeGame();
				//clientservice.getErrorHandler().doRGSAfterConsole("closeGame"); //SKATE-1299
				Logger.warn('com.igt.game: Halt');
				return;
			}
			if(consoleservice.isGamePaused()){
				allowDeferredLoading(false);
				Logger.warn('com.igt.game: waiting for unPause - console');
				consoleservice.setUnPauseGame(done);
			}else{
				done();
			}
		},
		function waitForWidgetUnpause() { //At the end of a transaction, check if pause requested
			if (gameLogicResponse.OutcomeDetail.GameStatus === 'InProgress') { //Don't let the widget pause until the end of the host game
				done();
			} else {
				if (widgetPauseHandler.ifWidgetPauseRequested()) {
					widgetPauseHandler.setUnpauseCallback(done);
					//Notify the widgets that a pause is now ready
					bus.publish({channel: "GameService", topic: "IXF.ToWidgets", data: {messageType: 'gamePaused', messageData:true}});
				} else {
					done();
				}
			}
		},
		function waitForTXDelay() { //SKATE-2655
			if (transactionDelay && gameLogicResponse.OutcomeDetail.GameStatus !== 'InProgress') { //SKATE-3400, this delay is being hit when in a tumbler :/
                //This is where we'd broadcast a message
				var timeNow = Date.now();
				var remaining = Math.max(0,(transactionDelay) - (timeNow-txStartTime));
				var endTime = Date.now() + remaining;
				if (remaining >= 500) {
					//console.log('TXDELAY','remaining: ',remaining,'resume time: ',endDateTime, new Date(endDateTime));
					bus.publish({channel: 'ClientService', topic: 'TransactionDelay', data: {remaining:remaining, endTime:endTime}});
				}
				setTimeout(done, remaining);
				//setTimeout(done, Math.max(0,(transactionDelay) - (Date.now()-txStartTime)));
			} else {
				done();
			}
		},
		function resetStakeValue() { //  SKATE-2798
			// reset stake
			if(stake && stake > 0){
				stake = 0;
			}
			done();
		},
		function onBeginNewGame(){
			allowDeferredLoading(false);
			if(gameLogicResponse.OutcomeDetail.GameStatus==='Start'){
				//SKATE-6037
				//This code only makes sense during PFS mode, to re-assert a PFS balance if a player has
				// triggered a topup.  They should not be doing that during PFS mode but at the very least
				// we'll keep it here to check.
				if (gameLogicResponse.PromotionalFreeSpin) {
					var balanceSumPfs = getTotalBalanceForPFS(gameLogicResponse.Balances);
					//set displayed balance in case the player has just topped up
					setBalance(gameLogicResponse.OutcomeDetail.Balance, undefined, balanceSumPfs);
				}
				gameProxy.callHandler('onBeginNewGame',gameLogicResponse.OutcomeDetail.NextStage,gameLogicResponse);
			}else{
				done();
			}
			//at this point we're pausing until next spin
			widgetPauseHandler.inRound(false);
			bus.publish({channel:"Kernel", topic:"Game.TakeFocus", data:{}}); //SKATE-4621 Space-To-Spin, send focus back to the game
			//We do this because calling document.getElementById('game').contentWindow.focus(); will break cross-frame when using CDN
		}
	].map(wrapNextState));

	// Aborted Transaction Queue
	var afterAbortQueue = FunctionQueue.apply(void 0,[
		function onSetCurrentBalance(){
			setCurrentTotalBalance(gameLogicResponse.OutcomeDetail.Balance);
			done();
		},
		function onAbortNextStage(){
			bus.publish({channel: 'Kernel', topic: 'BlockGame', data: false });
			//If the game was blocked during a transition, we unblock so that the game can resume.
			var balanceSumPfs = getTotalBalanceForPFS(gameLogicResponse.Balances);
			allowDeferredLoading(false);
			//set displayed balance to returned balance so player see what they actually have when messages are shown
			setBalance(gameLogicResponse.OutcomeDetail.Balance, undefined, balanceSumPfs);
			gameProxy.callHandler('onAbortNextStage',gameLogicResponse.OutcomeDetail.NextStage,gameLogicResponse);
		},
		function wagerAborted(){
			if(gameservice){//game round is ended
				gameservice.setInGameRound(false, "wagerAborted");
				bus.publish({channel: "GameService", topic: "IXF.ToWidgets", data: {messageType: 'gameEnd', messageData:{status:"WagerAborted"}}});
			}
			GameBusy("WagerState",false); //abort so no longer in game state
			consoleservice.wagerAborted(done);
		},
		function showAbortMessages(){
			consoleservice.showAnyMessages(done);
		},
		function onResetNextStage(){ //NOTE, should the abort flow also send pause to widget if requested.
			// SKATE-924, no need sending the balance again, otherwise the topup balance update will overwritten by this one
			//setBalance(gameLogicResponse.OutcomeDetail.Balance);
			widgetPauseHandler.inRound(false);
			gameProxy.callHandler('onResetNextStage',gameLogicResponse.OutcomeDetail.NextStage,gameLogicResponse);
		}
	].map(wrapNextState));

	// Exception Queue
	/*
	var exceptionQueue = FunctionQueue.apply(void 0,[
		function test(){

		}
	].map(wrapNextState));
	*/
	//This definitely feels like it should live in errorflow handler and be able to be sent to consoleservice
	var errorFlowHandler = function (command, continuation) {
		//Pass command to console (unless the command is insufficient funds; that's a message)
		if (command['@name'] === 'insufficientFundsNotification') {

			// If we have a valid response send to console immediately
			if (gameLogicResponse){
				consoleservice.sendOutcome(gameLogicResponse);
			}
			consoleservice.insufficientFundsNotification(function (){
				// PS - Shouldn't this be where we check for more messages?
				// Done continuation here cannot be a trigger for State Controller to transition to next state.
				// It is too early.
				continuation();
			});
		} else if (command['@name'] === 'viewAccountHistory') {
			consoleservice.viewAccountHistory(command.Param, function(response){
				continuation(command['@name'], (response!==void(0) && !response)?void(0):command['Param']); //SKATE-2651 - if the console doesn't send '0' pass the params through, otherwise pass nothing
			});
		} else if (command['@name'] === 'abort') {
			if (afterAbortQueue && beforeRequestQueue) {
				afterAbortQueue.execute(beforeRequestQueue.execute);
			} else {
				consoleservice.doMessageCommand(command, continuation);
			}
		} else if (command['@name'] === 'pfsReload'){ // get token from server side

			consoleservice.onUpdateParams(function(updateParam){
				var serverParams = command.Param;
				if(updateParam){
                    Object.keys(updateParam).forEach(function(param) {
                        serverParams[param] = updateParam[param];
                    });
				}

				if(command['@name'] === 'pfsReload'){
					clientservice.setSwitchPlayMode("PFS_TO_WAGER", serverParams);
				}
                continuation(command['@name'],serverParams);
			});
		}
		else {
			consoleservice.doMessageCommand(command, continuation);
		}
	};
	
	function registerPFSInfoNotification(pfsInfo) {
		var gameListNow = pfsInfo && pfsInfo.gameList ? pfsInfo.gameList : [];
		gameListNow.forEach(function (game) {
			game.offers.forEach(function (offer) {
				if(offer.hasOwnProperty('freespinBetInCurrency')){
					offer.freespinBetInCurrency =  currency.formatFloat(parseFloat(offer.freespinBetInCurrency));
				}
				if(offer.hasOwnProperty('freespinBalanceInCurrency')){
					offer.freespinBalanceInCurrency = currency.formatFloat(parseFloat(offer.freespinBalanceInCurrency));
				}
			});
		});
		latestPFSGameList = gameListNow;

		consoleservice.registerPFSInfoNotification(latestPFSGameList, function(position) {
			// Try to get update param from console
			consoleservice.onUpdateParams(function(updatedParam){
				choosePFSOfferHandler(position, updatedParam);
			});
		});

		// Send the Promotional FreeSpin Info to Widget
		bus.publish({channel: "GameService", topic: "PFS.Offer", data: latestPFSGameList});
	}

	function choosePFSOfferHandler(position, extraParam) {
		function checkNumber(n){
			return !isNaN(parseFloat(n)) && isFinite(n);
		}
		if(!checkNumber(position[0]) || !checkNumber(position[1])){
			return;
		}
		Logger.log("PFS choose ",position);
		var params = {
			/*playMode : "freespin",
			playModeChoice : "freespin"*/
		};
		var gameParams = latestPFSGameList[position[0]];
		for(var key in gameParams){
			if(key !== "gameTitle" && key !== "offers"){
				params[key] = gameParams[key];
			}
		}
		var offerParams = gameParams.offers[position[1]];
		for(let key in offerParams){
			if(key !== "freespinBetInCurrency" && key !== "freespinBalanceInCurrency"){
				params[key] = offerParams[key];
			}
		}
		if(extraParam && extraParam.constructor && extraParam.constructor === Object && extraParam.topic !== "PFS.Accept"){
			for(let key in extraParam){
				params[key] = extraParam[key];
			}
		}

		//For same game, switch to wager, for different game, have to reload
		var action = "reloadGame";
		if(compareMandatoryProperties(params, clientConfig.serverConfig.paramRGS, [
			"softwareid", "language"
		])) {
			//TODO update param for RGS lines, etc. - Lijian
			clientservice.setSwitchPlayMode("WAGER_TO_PFS", params);
			action = "switchWagerToPFS";
		}
		clientservice.getErrorHandler().doRGSAfterConsole(action, params);
	}

	function compareMandatoryProperties(obj1, obj2, props){
		var i = 0;
		while(i < props.length){
			if(obj1 && obj1.hasOwnProperty(props[i]) && obj2 && obj2.hasOwnProperty(props[i])){
				if(String(obj1[props[i]]) !== String(obj2[props[i]])){
					return false;
				}
			}else{
				return false;
			}
			i++;
		}
		return true;
	}

	
	var getExtraInfos = function(data){
		if(data.extraInfo && Array.isArray(data.extraInfo)){
			extraInfo = JSON.parse(JSON.stringify(data.extraInfo));
		}
	};


	var handlerExtraInfos = function (extraInfos) {

		for(var i = 0; i < extraInfos.length; i++){
			var item = extraInfos.shift();

			//Handle the pfs notificaiton
			if(item.hasOwnProperty("pfsNotification")){
				registerPFSInfoNotification(item.pfsNotification);
			}
		}

	};

	var clearExtraInfo = function() {
		extraInfo = [];
	};


	export default function(config,done){

		if(!config){
	    	throw new Error("com.igt.skateboard: StateController initialize error: config parameter required");
	    }

		if(!(done instanceof Function)){
			throw new Error("com.ig.skateboard: StateController initialize error: no done continuation passed in constructor");
		}

		// Pass a bus instance to begin pub/sub messaging
		//bus = config.bus(); //this will no longer work if we're requiring the bus

		// grab currency formatter from config
		currency = config.currency;

		// state controller receives client config (to deal with scenarios such as promotional freespin)
		clientConfig = config.clientconfig;
		gameType = clientConfig.gameConfig.gameType;

		//SKATE-4980 disable game type checking
		if(clientConfig.serverConfig.transactionDelay) {// && (clientConfig.gameConfig.gameType === 'S' || clientConfig.gameConfig.gameType === 'T')){ //SKATE-2655 + SKATE-4081 for Table games
			transactionDelay = Number(clientConfig.serverConfig.transactionDelay) * 1000;
		}

        //todo Load handler code for widget interface direct from game service here, work out moving it afterwards

		/*
			//deprecated
		if (clientConfig.serverConfig.gameVersion) { //BROWNPA - turns out not so deprecated, it's still in use!
			//gameVersion = clientConfig.serverConfig.gameVersion;
			gameVersionObj = {"gameVersion": clientConfig.serverConfig.gameVersion};
		}
		*/

		if(clientConfig.gameConfig.clientVersion && clientConfig.gameConfig.gleVersion){
			gameVersionObj = {
				"gameVersion": clientConfig.gameConfig.clientVersion,
				"gleVersion": clientConfig.gameConfig.gleVersion
			};
			if (clientConfig.serverConfig.gameVersion) {
				gameVersionObj.gameServerVersion = clientConfig.serverConfig.gameVersion;
				gameVersionObj.gameServerVersionShort = clientConfig.serverConfig.gameVersion.split('.', 2).join('.');
			}

		}

		// Pass initialised references to our subsystems in order to direct the flow between them
		consoleservice = config.consoleservice;
		clientservice = config.clientservice();
		gameservice = config.gameservice;

		// reveal subsystems when ready
		reveal = config.reveal;
		cecCommand = config.cecCommand;
		resizeManager.setCECCommand(cecCommand);

		//Wait to wire up error handler
		//Do we even need errorhandler ready?

		//This code would also work - I wonder if
		// import (/* webpackChunkName: "clientservice" */ "clientservice/errorhandler/ActionRunner").then((module) => {
		// 	console.log('ERR', 'OK, here we go', module.default);
		// 	module.default().setErrorFlowHandler(errorFlowHandler);
		// });

		//NO LONGER NEEDED TO WAIT - it initialises as soon as FC is loaded during loadConsoleService in bootstrap
		//bus.subscribe({channel:"ClientService",topic:"System.ErrorHandlerReady", callback:function(data,envelope){
			clientservice.getErrorHandler().setErrorFlowHandler(errorFlowHandler);
			consoleservice.connectActionRunner(clientservice.getErrorHandler().doRGSAfterConsole);
		//}});

		// Wait for System.Ready before beginning the State Flow
		bus.subscribe({channel:"Kernel",topic:"System.Ready",callback:function(data,envelope){
			initQueue.execute(beforeRequestQueue.execute);
		}});

		bus.subscribe({channel:"Game",topic:"Game.DeductStake",callback:function(data,envelope){
			stake = data;
			Logger.log("Game stake is: ", stake);
			deductStake(data);
		 }});

		bus.subscribe({channel:"ConsoleService", topic:"Option.StakeDeduction", callback:function(data) {
			bypassStakeDeduction = !data.enabled;
		}});

		//SKATE-5982, listen for paytable/rules/settings panels being open
		// and trigger a gamebusy state *IF* those controls report their open/closed status
		//SKATE-6545: We were erroneously listening to triggers from the console instead of replies from the game
		const truthify = (()=>{
			const noList = ["0","n","no", "N", "NO", "false", "False"];
			return function(input) {
				return noList.indexOf(input) < 0 && !!input;
			};
		})();
		bus.subscribe({channel: 'Game', topic: 'Game.Control', callback: function(data) {
			if (data?.event !== 'change' || !data?.name || (data.params === undefined && data.value === undefined)) {
				return; //Not a change event or no control name or no control params
			}
			//We only care about the following three controls, but treat them the same
			switch (data?.name) {
				case 'paytable':
				case 'howToPlay':
				case 'settings':
					GameBusy(data.name,data.params?truthify(data.params[0]):data?.value === true);
					break;
			}
		}});

		// Listen to console update balance when top up from cashier
		bus.subscribe({channel: "ConsoleService",topic: "BalanceUpdate",callback: function(data, envelop){
			if(data && data.balance && !isNaN(data.balanceValue)){
				setCurrentTotalBalance(data.balanceValue);
				//value technically dirty.
				clientservice.silentBalanceUpdate(function(newBalance, balancesNode){ //function will be called if data update successful
					if (newBalance) {
						var balanceSumPfs = getTotalBalanceForPFS(gameLogicResponse.Balances);
						setCurrentTotalBalance(newBalance);
						setBalance(newBalance, balancesNode, balanceSumPfs);
					}
				}); //trigger a silent balance update
			}
		}});

		/*
		data format which receive from game side for 'Game/Game.ReInit':
			{"gameConfig": {"wagerType": "BUY"}}
		*/
		function gameReinitConfigUpdate (data) {
			var updateServices = ['ClientService','ConsoleService'];
			var configUpdateAckSubscriber;
			
			function updateAckCallback(ack, envelope){
				var index = updateServices.indexOf(ack.success);
				if(index < 0) {
					Logger.warn(ack.success, ' is not the service must be updated');
				} else {
					updateServices.splice(index,1);
				}
				if(updateServices.length === 0) { // all required services been updated
					bus.unsubscribe(configUpdateAckSubscriber);
					// Trigger Execute ReInit Queue
					reInitQueue.execute(beforeRequestQueue.execute);
				}
			}

			configUpdateAckSubscriber = bus.subscribe({channel:"Kernel",topic:"Kernel.UpdateConfig.Ack", callback: updateAckCallback});
			bus.publish({channel:"Kernel",topic:"Kernel.UpdateConfig",data: data});
		}

		bus.subscribe({channel:"Game",topic:"Game.ReInit", callback: gameReinitConfigUpdate});

		bus.subscribe({channel:"Game", topic:"DeferredLoadProgress", callback:function(payload, envelope) { //SKATE-1849
			if (payload.fail && gameDLErrorEnabled) {
				//Check if this is happening in a permitted state.
				bus.publish({channel: "Kernel", topic: "ErrorHandler.Throw", data: {errorCode:'FT-002', priority : 0}});
			} else {
				Logger.warn('Deferred load progress error thrown during state where game is not in control.');
			}
		}});

		bus.subscribe({channel: "GameService", topic: "GameService.PromotionFreespinMessage", callback: registerPFSInfoNotification});
		bus.subscribe({channel: "GameService", topic: "PFS.Accept", callback: choosePFSOfferHandler});
		
		done();

	}

//});
